export default __webpack_public_path__ + "static/media/benefit_8.37015905.png";